import { take, put, race, select, spawn, all, fork, call, cancel, putResolve } from 'redux-saga/effects'
import { joinChannel, partChannel } from 'api/Api'
import { createSagasActions } from 'utils/sagas'
import {
  setLoadStatus
} from 'store/redux/layout'
import { landingPageActionsListener } from 'routes/Home/sagas'
import { myBoardActionsListener } from 'routes/MyBoard/sagas'
import { userGroupsActionsListener } from 'routes/UserGroups/sagas'
import initApp from './initApp'
import uploadListener from './uploadListener'
import uploadTemplateListener from './uploadTemplateListener'
import viewError from './viewError'
import _ from 'lodash'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

export const NAMESPACE = 'KanBo/sagas/'
export const INIT_APP = NAMESPACE + 'INIT_APP'
export const STOP_SAGA = NAMESPACE + 'STOP_SAGA'
export const FETCH_ALL_DOCUMENT_SOURCES_DETAILS = NAMESPACE + 'FETCH_ALL_DOCUMENT_SOURCES_DETAILS'
export const FETCH_BOARD_INFO = NAMESPACE + 'FETCH_BOARD_INFO'
export const FETCH_BOARD_TILE = NAMESPACE + 'FETCH_BOARD_TILE'
export const FETCH_BOOKMARKS = NAMESPACE + 'FETCH_BOOKMARKS'
export const FETCH_DOCUMENT_SOURCE_DETAILS = NAMESPACE + 'FETCH_DOCUMENT_SOURCE_DETAILS'
export const FETCH_DOCUMENT_SOURCES = NAMESPACE + 'FETCH_DOCUMENT_SOURCES'
export const FETCH_DOCUMENT_TEMPLATE_SOURCES = NAMESPACE + 'FETCH_DOCUMENT_TEMPLATE_SOURCES'
export const FETCH_DOCUMENT_SOURCE_TYPE_DETAILS = NAMESPACE + 'FETCH_DOCUMENT_SOURCE_TYPE_DETAILS'
export const FETCH_DOCUMENT_SOURCE_TYPES = NAMESPACE + 'FETCH_DOCUMENT_SOURCE_TYPES'
export const FETCH_FOLLOWED_CARDS = NAMESPACE + 'FETCH_FOLLOWED_CARDS'
export const FETCH_HEARTBEATS = NAMESPACE + 'FETCH_HEARTBEATS'
export const FETCH_NOTIFICATIONS = NAMESPACE + 'FETCH_NOTIFICATIONS'
export const FETCH_PERSONAL_DATES = NAMESPACE + 'FETCH_PERSONAL_DATES'
export const FETCH_PROFILE = NAMESPACE + 'FETCH_PROFILE'
export const FETCH_SEARCH_BOARDS = NAMESPACE + 'FETCH_SEARCH_BOARDS'
export const FETCH_SEARCH_CARDS = NAMESPACE + 'FETCH_SEARCH_CARDS'
export const FETCH_SEARCH_COMMENTS = NAMESPACE + 'FETCH_SEARCH_COMMENTS'
export const FETCH_SEARCH_DESKS = NAMESPACE + 'FETCH_SEARCH_DESKS'
export const FETCH_SEARCH_DOCUMENTS = NAMESPACE + 'FETCH_SEARCH_DOCUMENTS'
export const FETCH_SEARCH_USERS = NAMESPACE + 'FETCH_SEARCH_USERS'
export const FETCH_SP_USERS = NAMESPACE + 'FETCH_SP_USERS'
export const FETCH_UNREAD_NOTIFICATIONS_COUNT = NAMESPACE + 'FETCH_UNREAD_NOTIFICATIONS_COUNT'
export const FETCH_USER_ACTIVITIES = NAMESPACE + 'FETCH_USER_ACTIVITIES'
export const FETCH_USER_AVATAR = NAMESPACE + 'FETCH_USER_AVATAR'
export const FETCH_USER_GROUP_BOARDS = NAMESPACE + 'FETCH_USER_GROUP_BOARDS'
export const FETCH_USER_GROUP_OWNERS = NAMESPACE + 'FETCH_USER_GROUP_OWNERS'
export const FETCH_USER_GROUP_SYNC_TARGETS = NAMESPACE + 'FETCH_USER_GROUP_SYNC_TARGETS'
export const FETCH_USER_GROUP_TASKS = NAMESPACE + 'FETCH_USER_GROUP_TASKS'
export const FETCH_USER_GROUP_USERS = NAMESPACE + 'FETCH_USER_GROUP_USERS'
export const FETCH_USER_ROLES = NAMESPACE + 'FETCH_USER_ROLES'
export const FETCH_USERS_BY_ROLE = NAMESPACE + 'FETCH_USERS_BY_ROLE'
export const REQUEST_ACTIVATE_USER = NAMESPACE + 'REQUEST_ACTIVATE_USER'
export const REQUEST_ADD_ALARM = NAMESPACE + 'REQUEST_ADD_ALARM'
export const REQUEST_ADD_BOARD = NAMESPACE + 'REQUEST_ADD_BOARD'
export const REQUEST_ADD_DOCUMENT_SOURCE = NAMESPACE + 'REQUEST_ADD_DOCUMENT_SOURCE'
export const REQUEST_ADD_GROUP_OWNER_TO_USER_GROUP = NAMESPACE + 'REQUEST_ADD_GROUP_OWNER_TO_USER_GROUP'
export const REQUEST_ADD_PERSONAL_DATE = NAMESPACE + 'REQUEST_ADD_PERSONAL_DATE'
export const REQUEST_ADD_SYNC_TARGET_TO_USER_GROUP = NAMESPACE + 'REQUEST_ADD_SYNC_TARGET_TO_USER_GROUP'
export const REQUEST_ADD_USER_OWNER_TO_USER_GROUP = NAMESPACE + 'REQUEST_ADD_USER_OWNER_TO_USER_GROUP'
export const REQUEST_ADD_USER_ROLE = NAMESPACE + 'REQUEST_ADD_USER_ROLE'
export const REQUEST_CHANGE_BOARD_INFO = NAMESPACE + 'REQUEST_CHANGE_BOARD_INFO'
export const REQUEST_CHANGE_CURRENT_USER_AVATAR = NAMESPACE + 'REQUEST_CHANGE_CURRENT_USER_AVATAR'
export const REQUEST_CHANGE_CURRENT_USER_PROFILE = NAMESPACE + 'REQUEST_CHANGE_CURRENT_USER_PROFILE'
export const REQUEST_CHANGE_DOCUMENT_SOURCE_NAME = NAMESPACE + 'REQUEST_CHANGE_DOCUMENT_SOURCE_NAME'
export const REQUEST_CHANGE_PERSONAL_DATE = NAMESPACE + 'REQUEST_CHANGE_PERSONAL_DATE'
export const REQUEST_CHANGE_USER_GROUP_DESCRIPTION = NAMESPACE + 'REQUEST_CHANGE_USER_GROUP_DESCRIPTION'
export const REQUEST_CHANGE_USER_GROUP_NAME = NAMESPACE + 'REQUEST_CHANGE_USER_GROUP_NAME'
export const REQUEST_CHANGE_USER_SETTINGS = NAMESPACE + 'REQUEST_CHANGE_USER_SETTINGS'
export const REQUEST_DEACTIVATE_USER = NAMESPACE + 'REQUEST_DEACTIVATE_USER'
export const REQUEST_DOWNLOAD_BOARD_TEMPLATE = NAMESPACE + 'REQUEST_DOWNLOAD_BOARD_TEMPLATE'
export const REQUEST_DOWNLOAD_LAYOUT_TEMPLATE = NAMESPACE + 'REQUEST_DOWNLOAD_LAYOUT_TEMPLATE'
export const REQUEST_HEARTBEAT = NAMESPACE + 'REQUEST_HEARTBEAT'
export const REQUEST_MARK_ALL_NOTIFICATIONS_AS_READ = NAMESPACE + 'REQUEST_MARK_ALL_NOTIFICATIONS_AS_READ'
export const REQUEST_MARK_NOTIFICATION_AS_READ = NAMESPACE + 'REQUEST_MARK_NOTIFICATION_AS_READ'
export const REQUEST_MARK_NOTIFICATION_AS_UNREAD = NAMESPACE + 'REQUEST_MARK_NOTIFICATION_AS_UNREAD'
export const REQUEST_MARK_TAGGED_NOTIFICATIONS_AS_READ = NAMESPACE + 'REQUEST_MARK_TAGGED_NOTIFICATIONS_AS_READ'
export const REQUEST_REMOVE_ALARM = NAMESPACE + 'REQUEST_REMOVE_ALARM'
export const REQUEST_REMOVE_DOCUMENT_SOURCE = NAMESPACE + 'REQUEST_REMOVE_DOCUMENT_SOURCE'
export const REQUEST_REMOVE_GROUP_OWNER_FROM_USER_GROUP = NAMESPACE + 'REQUEST_REMOVE_GROUP_OWNER_FROM_USER_GROUP'
export const REQUEST_REMOVE_PERSONAL_DATE = NAMESPACE + 'REQUEST_REMOVE_PERSONAL_DATE'
export const REQUEST_REMOVE_SYNC_TARGET_FROM_USER_GROUP = NAMESPACE + 'REQUEST_REMOVE_SYNC_TARGET_FROM_USER_GROUP'
export const REQUEST_REMOVE_USER_OWNER_FROM_USER_GROUP = NAMESPACE + 'REQUEST_REMOVE_USER_OWNER_FROM_USER_GROUP'
export const REQUEST_REMOVE_USER_ROLE = NAMESPACE + 'REQUEST_REMOVE_USER_ROLE'
export const REQUEST_RENAME_PERSONAL_DATE = NAMESPACE + 'REQUEST_RENAME_PERSONAL_DATE'
export const REQUEST_REPAIR_ALL_DOCUMENT_SOURCES = NAMESPACE + 'REQUEST_REPAIR_ALL_DOCUMENT_SOURCES'
export const REQUEST_REPAIR_DOCUMENT_SOURCE = NAMESPACE + 'REQUEST_REPAIR_DOCUMENT_SOURCE'
export const REQUEST_UNFOLLOW_CARD = NAMESPACE + 'REQUEST_UNFOLLOW_CARD'
export const REQUEST_UNFOLLOW_CARDS_FROM_BOARD = NAMESPACE + 'REQUEST_UNFOLLOW_CARDS_FROM_BOARD'
export const REQUEST_SYNC_CURRENT_USER_PROFILE = NAMESPACE + 'REQUEST_SYNC_CURRENT_USER_PROFILE'
export const REQUEST_UPLOAD_START = NAMESPACE + 'REQUEST_UPLOAD_START'
export const REQUEST_UPLOAD_TEMPLATE_START = NAMESPACE + 'REQUEST_UPLOAD_TEMPLATE_START'
export const SHOW_SWEETALERT = NAMESPACE + 'SHOW_SWEETALERT'

const { getSagas, actionCreators } = createSagasActions([
  [CHANNEL_DATA, 'channelData', require('./channelData').default],
  [FETCH_ALL_DOCUMENT_SOURCES_DETAILS, 'fetchAllDocumentSourcesDetails', require('./fetchAllDocumentSourcesDetails').default],
  [FETCH_BOARD_INFO, 'fetchBoardInfo', require('./fetchBoardInfo').default],
  [FETCH_BOARD_TILE, 'fetchBoardTile', require('./fetchBoardTile').default],
  [FETCH_BOOKMARKS, 'fetchBookmarks', require('./fetchBookmarks').default, { takeLatest: true }],
  [FETCH_DOCUMENT_SOURCE_DETAILS, 'fetchDocumentSourceDetails', require('./fetchDocumentSourceDetails').default],
  [FETCH_DOCUMENT_SOURCES, 'fetchDocumentSources', require('./fetchDocumentSources').default],
  [FETCH_DOCUMENT_TEMPLATE_SOURCES, 'fetchDocumentTemplateSources', require('./fetchDocumentTemplateSources').default],
  [FETCH_FOLLOWED_CARDS, 'fetchFollowedCards', require('./fetchFollowedCards').default],
  [FETCH_HEARTBEATS, 'fetchHeartbeats', require('./fetchHeartbeats').default],
  [FETCH_NOTIFICATIONS, 'fetchNotifications', require('./fetchNotifications').default],
  [FETCH_PERSONAL_DATES, 'fetchPersonalDates', require('./fetchPersonalDates').default],
  [FETCH_PROFILE, 'fetchProfile', require('./fetchProfile').default],
  [FETCH_SEARCH_BOARDS, 'fetchSearchBoards', require('./fetchSearchBoards').default, { takeLatest: true }],
  [FETCH_SEARCH_CARDS, 'fetchSearchCards', require('./fetchSearchCards').default, { takeLatest: true }],
  [FETCH_SEARCH_COMMENTS, 'fetchSearchComments', require('./fetchSearchComments').default, { takeLatest: true }],
  [FETCH_SEARCH_DESKS, 'fetchSearchDesks', require('./fetchSearchDesks').default, { takeLatest: true }],
  [FETCH_SEARCH_DOCUMENTS, 'fetchSearchDocuments', require('./fetchSearchDocuments').default, { takeLatest: true }],
  [FETCH_SEARCH_USERS, 'fetchSearchUsers', require('./fetchSearchUsers').default, { takeLatest: true }],
  [FETCH_SP_USERS, 'fetchSPUsers', require('./fetchSPUsers').default, { takeLatest: true }],
  [FETCH_UNREAD_NOTIFICATIONS_COUNT, 'fetchUnreadNotificationsCount', require('./fetchUnreadNotificationsCount').default, { takeLatest: true }],
  [FETCH_USER_ACTIVITIES, 'fetchUserActivities', require('./fetchUserActivities').default],
  [FETCH_USER_AVATAR, 'fetchUserAvatar', require('./fetchUserAvatar').default, {
    reduce: (accumulator, payload) => ({
      profileKeys: _.uniq([ ...accumulator.profileKeys, ...payload.profileKeys ])
    })
  }],
  [FETCH_USER_GROUP_BOARDS, 'fetchUserGroupBoards', require('./fetchUserGroupBoards').default],
  [FETCH_USER_GROUP_OWNERS, 'fetchUserGroupOwners', require('./fetchUserGroupOwners').default],
  [FETCH_USER_GROUP_SYNC_TARGETS, 'fetchUserGroupSyncTargets', require('./fetchUserGroupSyncTargets').default],
  [FETCH_USER_GROUP_TASKS, 'fetchUserGroupTasks', require('./fetchUserGroupTasks').default],
  [FETCH_USER_GROUP_USERS, 'fetchUserGroupUsers', require('./fetchUserGroupUsers').default],
  [FETCH_USER_ROLES, 'fetchUserRoles', require('./fetchUserRoles').default],
  [FETCH_USERS_BY_ROLE, 'fetchUsersByRole', require('./fetchUsersByRole').default],
  [REQUEST_ACTIVATE_USER, 'requestActivateUser', require('./requestActivateUser').default],
  [REQUEST_ADD_ALARM, 'requestAddAlarm', require('./requestAddAlarm').default],
  [REQUEST_ADD_BOARD, 'requestAddBoard', require('./requestAddBoard').default],
  [REQUEST_ADD_DOCUMENT_SOURCE, 'requestAddDocumentSource', require('./requestAddDocumentSource').default],
  [REQUEST_ADD_GROUP_OWNER_TO_USER_GROUP, 'requestAddGroupOwnerToUserGroup', require('./requestAddGroupOwnerToUserGroup').default],
  [REQUEST_ADD_PERSONAL_DATE, 'requestAddPersonalDate', require('./requestAddPersonalDate').default],
  [REQUEST_ADD_SYNC_TARGET_TO_USER_GROUP, 'requestAddSyncTargetToUserGroup', require('./requestAddSyncTargetToUserGroup').default],
  [REQUEST_ADD_USER_OWNER_TO_USER_GROUP, 'requestAddUserOwnerToUserGroup', require('./requestAddUserOwnerToUserGroup').default],
  [REQUEST_ADD_USER_ROLE, 'requestAddUserRole', require('./requestAddUserRole').default],
  [REQUEST_CHANGE_BOARD_INFO, 'requestChangeBoardInfo', require('./requestChangeBoardInfo').default],
  [REQUEST_CHANGE_CURRENT_USER_AVATAR, 'requestChangeCurrentUserAvatar', require('./requestChangeCurrentUserAvatar').default],
  [REQUEST_CHANGE_CURRENT_USER_PROFILE, 'requestChangeCurrentUserProfile', require('./requestChangeCurrentUserProfile').default],
  [REQUEST_CHANGE_DOCUMENT_SOURCE_NAME, 'requestChangeDocumentSourceName', require('./requestChangeDocumentSourceName').default],
  [REQUEST_CHANGE_PERSONAL_DATE, 'requestChangePersonalDate', require('./requestChangePersonalDate').default],
  [REQUEST_CHANGE_USER_GROUP_DESCRIPTION, 'requestChangeUserGroupDescription', require('./requestChangeUserGroupDescription').default],
  [REQUEST_CHANGE_USER_GROUP_NAME, 'requestChangeUserGroupName', require('./requestChangeUserGroupName').default],
  [REQUEST_CHANGE_USER_SETTINGS, 'requestChangeUserSettings', require('./requestChangeUserSettings').default],
  [REQUEST_DEACTIVATE_USER, 'requestDeactivateUser', require('./requestDeactivateUser').default],
  [REQUEST_DOWNLOAD_BOARD_TEMPLATE, 'requestDownloadBoardTemplate', require('./requestDownloadBoardTemplate').default],
  [REQUEST_DOWNLOAD_LAYOUT_TEMPLATE, 'requestDownloadLayoutTemplate', require('./requestDownloadLayoutTemplate').default],
  [REQUEST_HEARTBEAT, 'requestHeartbeat', require('./requestHeartbeat').default],
  [REQUEST_MARK_ALL_NOTIFICATIONS_AS_READ, 'requestMarkAllNotificationsAsRead', require('./requestMarkAllNotificationsAsRead').default],
  [REQUEST_MARK_NOTIFICATION_AS_READ, 'requestMarkNotificationAsRead', require('./requestMarkNotificationAsRead').default],
  [REQUEST_MARK_NOTIFICATION_AS_UNREAD, 'requestMarkNotificationAsUnread', require('./requestMarkNotificationAsUnread').default],
  [REQUEST_MARK_TAGGED_NOTIFICATIONS_AS_READ, 'requestMarkTaggedNotificationsAsRead', require('./requestMarkTaggedNotificationsAsRead').default],
  [REQUEST_REMOVE_ALARM, 'requestRemoveAlarm', require('./requestRemoveAlarm').default],
  [REQUEST_REMOVE_DOCUMENT_SOURCE, 'requestRemoveDocumentSource', require('./requestRemoveDocumentSource').default],
  [REQUEST_REMOVE_GROUP_OWNER_FROM_USER_GROUP, 'requestRemoveGroupOwnerFromUserGroup', require('./requestRemoveGroupOwnerFromUserGroup').default],
  [REQUEST_REMOVE_PERSONAL_DATE, 'requestRemovePersonalDate', require('./requestRemovePersonalDate').default],
  [REQUEST_REMOVE_SYNC_TARGET_FROM_USER_GROUP, 'requestRemoveSyncTargetFromUserGroup', require('./requestRemoveSyncTargetFromUserGroup').default],
  [REQUEST_REMOVE_USER_OWNER_FROM_USER_GROUP, 'requestRemoveUserOwnerFromUserGroup', require('./requestRemoveUserOwnerFromUserGroup').default],
  [REQUEST_REMOVE_USER_ROLE, 'requestRemoveUserRole', require('./requestRemoveUserRole').default],
  [REQUEST_RENAME_PERSONAL_DATE, 'requestRenamePersonalDate', require('./requestRenamePersonalDate').default],
  [REQUEST_REPAIR_ALL_DOCUMENT_SOURCES, 'requestRepairAllDocumentSources', require('./requestRepairAllDocumentSources').default],
  [REQUEST_REPAIR_DOCUMENT_SOURCE, 'requestRepairDocumentSource', require('./requestRepairDocumentSource').default],
  [REQUEST_UNFOLLOW_CARD, 'requestUnfollowCard', require('./requestUnfollowCard').default],
  [REQUEST_UNFOLLOW_CARDS_FROM_BOARD, 'requestUnfollowCardsFromBoard', require('./requestUnfollowCardsFromBoard').default],
  [SHOW_SWEETALERT, 'showSweetalert', require('./showSweetalert').default, { queue: true }],
])

actionCreators.stopSaga = () => {
  return {
    type: STOP_SAGA
  }
}

export const sagaActions = actionCreators

export function * onStartSaga () {
  const state = yield select()

  const channels = [
    call(joinChannel, '@' + state.kanbo.currentUser.id),
    call(joinChannel, 'users'),
    call(joinChannel, 'documents-sources'),
    call(joinChannel, 'boardCollectionSettings'),
  ]

  if (state.kanbo.config.myBoard) {
    channels.push(call(joinChannel, 'vboard-' + state.kanbo.currentUser.myBoardId))
  }

  yield all(channels)
}

export function * onStopSaga () {
  const state = yield select()

  const channels = [
    call(partChannel, '@' + state.kanbo.currentUser.id),
    call(partChannel, 'users'),
    call(partChannel, 'documents-sources'),
    call(partChannel, 'boardCollectionSettings'),
  ]

  if (state.kanbo.config.myBoard) {
    channels.push(call(partChannel, 'vboard-' + state.kanbo.currentUser.myBoardId))
  }

  yield all(channels)
}

export function * rootActionsListener () {
  console.log('rootActionsListener has been started')

  try {
    yield race([
      ...getSagas(),
      call(uploadListener),
      call(uploadTemplateListener),
    ])
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }
}

export function * stop () {
  yield put(sagaActions.stopSaga())

  return
}

export function * init () {
  try {
    yield put(sagaActions.stopSaga())

    yield put(setLoadStatus({
      isLoading: true,
      isLoaded: false
    }))

    const forkedRootActionsListener = yield fork(rootActionsListener)
    const forkedLandingPageActionsListener = yield fork(landingPageActionsListener)
    const forkedMyBoardActionsListener = yield fork(myBoardActionsListener)
    const forkedUserGroupsActionsListener = yield fork(userGroupsActionsListener)

    yield put({ type: INIT_APP })

    yield initApp()

    yield call(onStartSaga)

    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: true
    }))

    yield take(STOP_SAGA)

    yield spawn(onStopSaga)

    yield cancel(forkedRootActionsListener)
    yield cancel(forkedLandingPageActionsListener)
    yield cancel(forkedMyBoardActionsListener)
    yield cancel(forkedUserGroupsActionsListener)
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }

  return
}
